export default "https://legacy.eskolare-development.com/images/person-buying.png";